<template>
  <div class="notification-container">
    <div v-for="(notification, i) in notifications" :key="`notification${i}`" class="notification-item">
      <b-notification
        :key="notification.id"
        :type="`is-${notification.notification_type}`"
        @close="close(notification.id)"
      >
        <div v-html="notification.message"></div>
      </b-notification>
    </div>
  </div>
</template>

<script>
export default {
  props: ['notifications'],
  methods: {
    close(id) {
      this.$emit('close', id)
    }
  }
}
</script>
<style scoped lang="scss">
.notification {
  padding: 0.5rem 1.5rem 0.5rem 0.5rem;
}
.notification-item:not(:last-child) {
  margin-bottom: 0.75rem;
}
</style>
